module.exports = __webpack_public_path__ + "img/A_customer_xing02.7153b95a.png";